import React from 'react';
import { View, Image, ScrollView, useWindowDimensions } from 'react-native';
import useTranslation from '../../hooks/translation-hook';
import CustomButton from '../common/CustomButton';
import Label from '../common/Label';

export interface LocationPermissionProps {
  onClose?(): void;
}

const heroImageAspectRatio = 350 / 234;

const LocationPermission = (props: LocationPermissionProps) => {
  const t = useTranslation();
  const layout = useWindowDimensions();
  const popupWidth = Math.min(390, Math.max(layout.width - 30, 300));
  const heroHeight = Math.round(popupWidth / heroImageAspectRatio);
  const isCompact = popupWidth < 340;
  const cardBackgroundColor = '#eeeef0';
  const titleColor = '#5e51a3';
  const bodyColor = '#33264d';
  const buttonColor = '#5e51a3';

  return (
    <ScrollView
      style={{ flexGrow: 0, width: popupWidth, backgroundColor: cardBackgroundColor }}
      contentContainerStyle={{ backgroundColor: cardBackgroundColor }}
      nestedScrollEnabled={true}
      bounces={false}
      alwaysBounceVertical={false}
      alwaysBounceHorizontal={false}
      overScrollMode="never"
    >
      <Image source={require('../../../assets/onBoarding_mobile_2.png')} style={{ width: popupWidth, height: heroHeight }} resizeMode="contain" />
      <View style={{ flexGrow: 1, marginTop: -1, backgroundColor: cardBackgroundColor }}>
        <View
          style={{
            paddingHorizontal: isCompact ? 24 : 30,
            paddingTop: isCompact ? 24 : 30,
            paddingBottom: 24,
            backgroundColor: cardBackgroundColor,
          }}
        >
          <Label style={{ fontSize: isCompact ? 27 : 30, lineHeight: isCompact ? 32 : 36, color: titleColor, fontWeight: '700' }} numberOfLines={3}>
            {t('We-will-need-to-access-your-location')}
          </Label>
          <Label style={{ marginTop: 22, fontSize: isCompact ? 16 : 17, lineHeight: isCompact ? 22 : 24, color: bodyColor }} numberOfLines={10}>
            {t('location-permission-message')}
          </Label>
          <CustomButton
            style={{ marginTop: 28, width: '100%', minHeight: 52, backgroundColor: buttonColor, borderColor: buttonColor }}
            textStyle={{ color: '#ffffff', fontSize: 15, lineHeight: 19, fontWeight: '700' }}
            title={t('got-it')}
            onPress={() => {
              props.onClose && props.onClose();
            }}
          />
        </View>
      </View>
    </ScrollView>
  );
};

export default LocationPermission;
